module.exports = __webpack_public_path__ + "img/heikin-ashi_select@2x.695d1647.svg";